import { Button, CircularProgress } from "@mui/material";
import useIsIntersecting from "helpers/useIsIntersecting";
import React, { useEffect, useRef, useState } from "react";

export default function FetchMoreButton({ dataMeta, rows, rowsCount = null, autoFetch = false, ...others }) {
  const ref = useRef();
  const [offset, offsetSet] = useState();
  // a fetch from this offset added no rows (e.g. count drifted from the list), stop or auto-fetch loops forever
  const stalled = offset === rows?.length;
  let endOfPage = stalled || (rowsCount != null && rows?.length >= rowsCount);
  if (dataMeta?.loading) endOfPage = false;

  const fetchMoreDisabled = !dataMeta || !rows || endOfPage || dataMeta.loading;
  const fetchMoreRun = async () => {
    if (fetchMoreDisabled) return;

    try {
      await dataMeta.fetchMore({
        variables: {
          offset: rows.length,
        },
      });
    } finally {
      offsetSet(rows.length);
    }
  };

  const isIntersecting = useIsIntersecting(ref);

  useEffect(() => {
    if ((autoFetch || isIntersecting) && !fetchMoreDisabled) {
      fetchMoreRun();
    }
  }, [autoFetch, isIntersecting, fetchMoreDisabled]);

  return (
    <Button
      color="inherit"
      onClick={fetchMoreRun}
      disabled={!dataMeta || !rows || endOfPage || dataMeta.loading}
      ref={ref}
      style={{
        padding: "1em",
        color: "inherit",
      }}
      {...others}
    >
      {endOfPage && <>End of results</>}
      {dataMeta?.loading && <CircularProgress color="inherit" size="1.5em" />}
      {dataMeta && !dataMeta.loading && !!rows && !endOfPage && <>Load More Results</>}
      {!!rows && (
        <span style={{ margin: "0 .5em", opacity: 0.5, fontSize: "0.8em" }}>
          (showing {rows.length}/{rowsCount === null ? "?" : rowsCount})
        </span>
      )}
    </Button>
  );
}
